/**
 * Google Review Prompt — Safer Lighting
 * Slide-up widget that prompts customers who have ordered to leave a Google
 * review. Only rendered for signed-in customers with orders (theme.liquid),
 * shown at most once per session, never on product/cart/checkout pages, and
 * respects a 30-day dismissal window stored in localStorage.
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'sl_review_dismissed';
  const SESSION_KEY = 'sl_review_shown';
  const DISMISS_DAYS = 30;

  function isDismissed() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      const ts = parseInt(raw, 10);
      if (isNaN(ts)) return false;
      return Date.now() - ts < DISMISS_DAYS * 24 * 60 * 60 * 1000;
    } catch (e) {
      return false;
    }
  }

  function markDismissed() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {}
  }

  function init() {
    if (isDismissed()) return;

    const el = document.getElementById('sl-review-prompt');
    if (!el) return;

    const href = window.location.href;
    const isOrderPage = /orders\/|thank.you|\/account/i.test(href);
    /* Never interrupt someone mid-purchase. */
    if (/\/products\/|\/cart|\/checkouts\//i.test(href)) return;
    try { if (sessionStorage.getItem(SESSION_KEY)) return; } catch (e) {}
    const delay = isOrderPage ? 2500 : 8000;

    const show = () => {
      el.classList.add('is-visible');
      try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
    };
    const dismiss = () => {
      el.classList.remove('is-visible');
      el.classList.add('is-dismissed');
      markDismissed();
    };

    el.querySelector('[data-review-close]')?.addEventListener('click', dismiss);
    el.querySelector('[data-review-cta]')?.addEventListener('click', markDismissed);

    setTimeout(show, delay);
  }

  // Guard: wait for DOM ready before querying elements
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
